import { IMAGES } from "@/lib/site";
import { Calendar, Sparkles } from "lucide-react";

const events = [
  {
    id: "hasanamba",
    name: "Hasanamba Festival, Hassan",
    when: "Once a Year • Deepavali Week",
    img: IMAGES.hasanambaTemple,
    desc:
      "Hasanamba Temple in Hassan dates back to the 12th century under the Hoysala dynasty. Dedicated to the goddess Shakti, the deity's name — meaning \"Smiling Mother\" in Kannada — gave the city of Hassan its name. The temple opens its doors for only one week annually during Deepavali, drawing devotees from across Karnataka.",
  },
  {
    id: "sakleshpur-jatre",
    name: "Sakleshpur Jatre",
    when: "Annual • Hemavathi Riverbank",
    img: IMAGES.sakleshpurJatre,
    desc:
      "The Sakleshpur Jatre — locally known as the Sri Sakleshwara Swamy Ratha Yatra — is a major annual cultural and religious festival held at the historic Sri Sakleshwara Swamy Temple. The temple, from which the town gets its name, dates back to the Hoysala dynasty (11th–14th century) and sits on the picturesque banks of the Hemavathi River.",
  },
];

const Events = () => {
  return (
    <section
      id="events"
      data-testid="events-section"
      className="relative py-24 md:py-32 bg-[#1B4332] text-white overflow-hidden"
    >
      <div className="absolute inset-0 opacity-10">
        <img
          src={IMAGES.flowerCanopy}
          alt=""
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="max-w-2xl reveal">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-[#D4AF37]" />
            <span className="text-[11px] tracking-[0.3em] uppercase text-[#D4AF37] font-medium">
              Yearly Cultural Events
            </span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Plan your stay around a{" "}
            <span className="italic font-light text-[#E8C866]">
              local celebration
            </span>
          </h2>
          <p className="mt-5 text-white/75 text-base md:text-lg leading-relaxed">
            Time your visit with one of these iconic Malnad festivals — a rare
            glimpse into centuries-old traditions of Hassan district.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6 md:gap-8">
          {events.map((e, i) => (
            <article
              key={e.id}
              className="reveal group relative rounded-3xl overflow-hidden bg-black/30 shadow-2xl aspect-[4/5] md:aspect-[16/13]"
              style={{ animationDelay: `${i * 0.08}s` }}
              data-testid={`event-card-${e.id}`}
            >
              <img
                src={e.img}
                alt={e.name}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f0f]/95 via-[#0f0f0f]/50 to-[#0f0f0f]/10" />
              <div className="absolute inset-0 p-7 md:p-9 flex flex-col justify-end">
                <div className="flex items-center gap-2 text-[#D4AF37] text-[10px] tracking-[0.25em] uppercase mb-3">
                  <Calendar size={13} strokeWidth={1.8} />
                  {e.when}
                </div>
                <h3 className="font-heading text-2xl md:text-3xl text-white leading-tight">
                  {e.name}
                </h3>
                <p className="mt-3 text-white/80 text-sm md:text-base leading-relaxed">
                  {e.desc}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center reveal">
          <div className="inline-flex items-center gap-3 px-5 py-3 rounded-full bg-white/5 border border-white/10 text-sm text-white/70">
            <Sparkles size={16} className="text-[#D4AF37]" />
            Ask us for exact dates when you book — we love arranging festival visits.
          </div>
        </div>
      </div>
    </section>
  );
};

export default Events;
